import { InventoryItemCurrencies } from '../enums/inventory-item-currencies.enum';

/**
 * Canonical list of currency codes the app supports. Derived from
 * {@link InventoryItemCurrencies} so the enum stays the single source of truth.
 * Consume this in templates that bind raw currency strings (e.g. sales-order line
 * pickers) via {@code @for (currency of SUPPORTED_CURRENCY_CODES; track currency)}.
 */
export const SUPPORTED_CURRENCY_CODES: readonly InventoryItemCurrencies[] = [
  InventoryItemCurrencies.UAH,
  InventoryItemCurrencies.EUR,
  InventoryItemCurrencies.USD,
];

/**
 * Currency select-option shape used by the goods overview tabs:
 * {@code { key: 'INVENTORY_ITEM_CURRENCIES.UAH', value: 'UAH' }}. The {@code key}
 * is the i18n key the template translates; {@code value} is the form value.
 */
export const CURRENCY_SELECT_OPTIONS: readonly { key: string; value: InventoryItemCurrencies }[] =
  SUPPORTED_CURRENCY_CODES.map((value) => ({
    key: `INVENTORY_ITEM_CURRENCIES.${value}`,
    value,
  }));
